






















import { getCardColor } from '@/main';
import { Component, Vue, Prop } from 'vue-property-decorator';
import CloseButton from '@/components/parts/CloseButton.vue';
import MobileDetect from 'mobile-detect';
import inobounse from 'inobounce';
import Decoration from '@/components/parts/Decoration.vue';

@Component({ components: { CloseButton, Decoration } })
export default class DecoratedModal extends Vue {
  @Prop({ default: 'orange' })
  variant?: string;
  @Prop({ default: false })
  noclose?: boolean;

  y = 0;
  count = 0;
  offset = 0;
  size = 0;

  get getVariant() {
    return this.variant;
  }

  get isNoClose() {
    return this.noclose;
  }

  mounted() {
    const md = new MobileDetect(window.navigator.userAgent);

    if (md.is('ios')) inobounse.enable();
    this.y = window.scrollY;
    document.documentElement.classList.add('mc-disable-scroll');
    document.body.classList.add('mc-disable-scroll');
    const app = document.getElementById('app');
    if (app) app.style.marginTop = `${-this.y}px`;

    window.addEventListener('resize', this.resize);
    this.resize();
  }

  resize() {
    const body = this.$refs.body as Element;
    this.size = body.clientHeight * 0.4;
    this.count = Math.floor((body.scrollHeight - this.size) / this.size) - 1;
    this.offset = this.size;
  }

  onClose(e: Event) {
    inobounse.disable();
    this.$emit('close', e);
  }

  onScroll(e: Event) {
    this.$emit('scroll', e);
  }

  getColor() {
    return getCardColor(this.variant);
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.resize);
  }
}
